import { BaseLayoutFactory } from '../../../components/base-layout-factory';
import { ManagementUnitSearchProvider } from './context/management-unit-search-context';
import { ManagementUnitSearchComponent } from './management-unit-search-component';

export function ManagementUnitSearchFactory() {
    return (
        <BaseLayoutFactory>
            <ManagementUnitSearchProvider>
                <ManagementUnitSearchComponent />
            </ManagementUnitSearchProvider>
        </BaseLayoutFactory>
    );
}
